import { ReviewData } from "@/Components/Client/Reviews/review";
import ReviewCarousel from "@/Components/Client/Reviews/ReviewCarousel";
import { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { CoachInfoSubcomponentProps } from "../CoachInfo";

export default function Reviews({ coachInfoData }: CoachInfoSubcomponentProps) {
    const [isOpen, setIsOpen] = useState(false);

    const reviews =
        (coachInfoData?.coach.reviews.filter(
            (review) => review.text,
        ) as ReviewData[]) ?? [];

    return !coachInfoData ? (
        <ReviewsSkeleton />
    ) : reviews.length !== 0 ? (
        <div>
            <button
                className="flex items-center gap-2 font-bold text-xl"
                onClick={() => setIsOpen(!isOpen)}
            >
                Coach Reviews
                {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
            </button>
            {isOpen && (
                <div className="mt-4 min-w-full max-w-full">
                    <ReviewCarousel reviews={reviews} />
                </div>
            )}
        </div>
    ) : null;
}

function ReviewsSkeleton() {
    return (
        <div className="text-brand-gray animate-pulse">
            <div className="flex items-center gap-2 font-bold text-xl">
                Coach Reviews
                <IoIosArrowDown />
            </div>
        </div>
    );
}
